import React, { Component } from 'react';
// import { getChildren } from '../../utils/constant';
// import { Container, Image, Text } from '../../components';

// const getIntroConfig = (props) => {
//   const { title, titleFontSize, titleFontWeight, contentFontSize, contentFontWeight, subTitle, actor, description, background = 'inherit', imgUrl, cid, vid, color = '#fff' } = props;
//   const config = [{
//     name: "Container",
//     props: {
//       width: '95%',
//       background: background,
//     },
//     children: [
//       {
//         name: "Container",
//         props: {
//           width: '95%'
//         },
//         children: [
//           {
//             name: "Image",
//             props: {
//               src: imgUrl,
//               size: 'default-vt',
//               params: {
//                 cid,
//                 vid,
//               },
//               onClick: 'openView'
//             },
//           },
//           {
//             name: "Container",
//             props: {
//               size: 'half',
//               width: '60%',
//               paddingRight: '10px',
//             },
//             children: [
//               {
//                 name: "Text",
//                 props: {
//                   size: 'big',
//                   text: title,
//                   color: color,
//                   fontSize: titleFontSize && `${titleFontSize}px`,
//                   fontWeight: titleFontWeight && titleFontWeight
//                 }
//               },
//               {
//                 name: "Text",
//                 props: {
//                   size: 'small',
//                   text: subTitle,
//                   color: color,
//                   fontSize: contentFontSize && `${contentFontSize}px`,
//                   fontWeight: contentFontWeight && contentFontWeight
//                 }
//               },
//               {
//                 name: "Text",
//                 props: {
//                   size: 'small',
//                   text: `${actor}`,
//                   color: color,
//                   padding: '8px 0',
//                   lineHeight: '1.0',
//                   fontSize: contentFontSize && `${contentFontSize}px`,
//                   fontWeight: contentFontWeight && contentFontWeight
//                 }
//               },
//               {
//                 name: "Text",
//                 props: {
//                   size: 'small',
//                   text: `${description}`,
//                   color: color,
//                   fontSize: contentFontSize && `${contentFontSize}px`,
//                   fontWeight: contentFontWeight && contentFontWeight
//                 }
//               },
//             ]
//           }
//         ]
      
//       }
//     ]
//     },
//   ];

//   return config;
// }

export class OneImgWithIntro extends Component {

  render() {
    const customAttributes = {
    };
    return (
      <div {...this.props} {...customAttributes}>{this.props.children}</div>
    );
  }
}


export default OneImgWithIntro;
